const LOADER_KEY = 'commodit_loader_shown';

export const shouldShowLoader = (): boolean => {
  // Check if it's a force refresh (Ctrl+F5 or Cmd+Shift+R)
  const isForceRefresh = 
    performance.getEntriesByType('navigation')[0]?.['type'] === 'reload' &&
    (performance as any).navigation?.type === 1;
  
  if (isForceRefresh) {
    localStorage.removeItem(LOADER_KEY);
    return true;
  }

  // Show loader only if it has never been shown before
  const hasBeenShown = localStorage.getItem(LOADER_KEY);
  return !hasBeenShown;
};

export const markLoaderShown = (): void => {
  localStorage.setItem(LOADER_KEY, 'true');
};
